module.exports = __webpack_public_path__ + "somers.jpg?375eeb70e060aaf89602d2bc045bfdc6";